<template>
  <div id="app">
    <div id="wrapper" class="wrapper">
      <span id="home"></span>
      <Menu></Menu>
      <transition name="fade">
        <router-view :url="'/'"></router-view>
      </transition>
      <div class="section fp-section mt-5" data-anchor="fifth-section">
        <section id="logos" class="cr-section contact-area  bg-white">
          <div class="container">
            <div class="row justify-content-between" v-if="logos && logos.length>0">
              <VueSlickCarousel :autoplay="true" :infinite="true" :responsive="responsive" :autoplaySpeed="5000"
                                :arrows="false" :dots="false"
                                :dotsClass="'hero-pagination-dots'"
                                :cssEase="'ease-in-out'"
                                :lazyLoad="'ondemand'"
                                :slidesToShow="6"
                                :slidesToScrol="6"
                                >
                <div v-for="logo in logos" v-bind:key="'logo-'+logo.id">
                  <div class="text-center">
                   <ImageLazy :image="logo.image" :style="'margin:auto'" :height="80" :title="logo.title" :alt="logo.description"></ImageLazy>
                  </div>
                </div>
              </VueSlickCarousel>
            </div>
          </div>
        </section>
      </div>
      <div class="section fp-section pt-0" data-anchor="fifth-section">
        <section id="contact" class="cr-section contact-area section-padding-xlg bg-white pb-0">
          <div class="container">
            <div class="row justify-content-between">
              <div class="col-xl-6 col-lg-6">
                <div class="section-title">
                  <h2>{{ $t('Kapcsolat') }}</h2>
                  <p>{{ $t('Első lépésként írj nekünk, hogy megtudd van e szabad hely a naptárunkban.') }}</p>
                </div>
                <div id="contact-form" class="photoghor-form">
                  <div class="photoghor-form-inner">
                    <div class="photoghor-form-input photoghor-form-input-half">
                      <input type="text" v-model="model.name" :placeholder="$t('Név*')" required="">
                    </div>
                    <div class="photoghor-form-input photoghor-form-input-half">
                      <input type="email" v-model="model.email" :placeholder="$t('Email*')" required="">
                    </div>
                    <div class="photoghor-form-input">
                      <input type="text" v-model="model.subject" :placeholder="$t('Tárgy*')" required="">
                    </div>
                    <div class="photoghor-form-input">
                      <input type="text" v-model="model.date" :placeholder="$t('Fotózás dátuma')">
                    </div>
                    <div class="photoghor-form-input">
                      <input type="text" v-model="model.location" :placeholder="$t('Fotózás helyszíne')">
                    </div>
                    <div class="photoghor-form-input">
                      <select type="text" v-model="model.info">
                        <option value="">{{ $t('Hogyan találtál ránk?') }}</option>
                        <option value="google">Google</option>
                        <option value="facebook">Facebook</option>
                        <option value="instagram">Instagram</option>
                        <option value="pinterest">Pinterest</option>
                        <option value="youtube">Youtube</option>
                        <option value="other">{{ $t('Egyéb') }}</option>
                      </select>
                    </div>
                    <div class="photoghor-form-input">
                      <textarea cols="30" v-model="model.message" rows="5" :placeholder="$t('Üzenet*')"></textarea>
                    </div>
                    <div class="alert alert-danger w-100 m-2" v-if="errorMessage">{{ errorMessage }}</div>
                    <div class="alert alert-success w-100 m-2" v-if="message">{{ message }}</div>
                    <div class="photoghor-form-input">
                      <button @click="submitContact" type="button" class="button" :aria-label="$t('Elküldés')"
                              :data-content="$t('Elküldés')">
                        <span>{{ $t('Elküldés') }}</span>
                      </button>
                    </div>
                  </div>
                </div>
                <p class="form-message"></p>
              </div>
              <div class="col-xl-5 col-lg-6">
                <div class="contact-info-wrapper">
                  <div class="section-title">
                    <h1>NK creative</h1>
                    <p>{{ $t('...ahol a pillanat emlékké változik...') }}</p>
                  </div>
                  <div class="contact-info">
                    <div class="single-info">
                      <h5>{{ $t('Telefon') }}</h5>
                      <p><a href="tel:+36205836133">+36205836133</a> / <a href="tel:+36204222089">+36204222089</a></p>
                    </div>
                    <div class="single-info">
                      <h5>Email</h5>
                      <p><a href="mailto: info@nkcreative.hu"> info@nkcreative.hu</a></p>
                    </div>
                    <div class="single-info">
                      <h5>{{ $t('Cím') }}</h5>
                      <p>1076 Budapest Szinva utca 5</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div class="section fp-section pt-0" data-anchor="fifth-section mb-5mt-3">
          <section id="insta" class="cr-section contact-area section-padding-xlg bg-white pt-0 pb-0">
            <div class="container">
             <Insta></Insta>
              </div>
          </section>
        </div>
        <footer id="footer-area" class="footer-area section-padding-xs bg-dark">
          <div class="container">
            <div class="row">
              <div class="col-lg-6">
                <ul class="footer-social-links">
                  <li><a href="https://www.facebook.com/nk.creative.wedding" target="_blank">Facebook</a></li>
                  <li><a href="https://www.instagram.com/nk_creative_photography/" target="_blank">Instagram</a></li>
                  <li><a href="https://www.youtube.com/channel/UCdJpadjISX9nFPhfo7BtHQA" target="_blank">Youtube </a>
                  </li>
                  <li><a href="https://hu.pinterest.com/nk_creative/" target="_blank">Pinterest </a></li>
                </ul>
              </div>
              <div class="col-lg-6">
                <div class="footer-copyright">
                  <p>Copyright © 2021. All Right Reserved</p>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from './components/Menu'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import ImageLazy from './components/ImageLazy'
import Insta from './components/Insta'

export default {
  name: 'App',
  components: {
    Menu,
    VueSlickCarousel,
    ImageLazy,
    Insta
  },
  data () {
    return {
      model: {
        info: ''
      },
      responsive: [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 6
          // centerMode: true,

        }

      }, {
        breakpoint: 800,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          autoplay: true,
          autoplaySpeed: 2000

        }

      }, {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          autoplay: true,
          autoplaySpeed: 2000

        }
      }],
      logos: [],
      message: '',
      errorMessage: ''
    }
  },

  methods: {
    submitContact () {
      this.axios.post(this.$host + 'contact', this.model).then(resp => {
        this.model = {
          info: ''
        }
        this.errorMessage = ''

        this.message = 'Köszönjük a megkérést! Hamarosan felvesszük veled a kapcsolat.'
      }).catch(() => {
        this.message = ''
        this.errorMessage = 'A *-al jelölt mezők kitöltése kötelező'
      })
    },
    getLogos () {
      this.axios.get(this.$host + 'partners/logo').then(resp => {
        this.logos = resp.data.data
      }).catch(() => {
        this.loaded = true
      })
    }
  },
  mounted () {
    this.getLogos()
  }

}
</script>

<style>
@import './assets/style.css';
</style>



// WEBPACK FOOTER //
// src/App.vue